module.exports = __webpack_public_path__ + "img/pek_33_halo.32bee075.png";